import { MenuPopover } from "@reach/menu-button";
import { styled } from "styled-components";
const DropdownMenuPopover = styled(MenuPopover)({
  "&[hidden]": {
    display: "block"
  }
});
export {
  DropdownMenuPopover
};
